import angular from 'angular'

import component from './progressbar.component'

let module = angular.module('progressbar', [])

.component('progressbar', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/progressbar/index.js